<template>
  <div
    ref="contentModal"
    aria-hidden="true"
    aria-labelledby="contentModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content position-relative">
        <div class="modal-header">
          <h5 class="modal-title textStyle">
            {{ title }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <slot v-if="$slots.content" name="content"></slot>
          <div v-else v-html="content"></div>
          <div class="d-flex align-items-center justify-content-center mt-4" v-if="cancelBtn">
            <button class="btn btn-danger" data-bs-dismiss="modal" data-dismiss="modal" type="button">
              {{ $t("close") }}
            </button>
          </div>
        </div>
        <BlockLoader :loading="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import BlockLoader from "@/components/blocks/BlockLoader.vue";

export default {
  name: "ModalComponent",
  components: { BlockLoader },
  props: {
    title: {
      type: String,
      required: true,
      default: "",
    },
    content: {
      type: String,
      required: false,
      default: "",
    },
    opened: {
      type: Boolean,
      required: true,
      default: false,
    },
    cancelBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    opened() {
      const container = this.$refs.contentModal;
      const modal = new Modal(container);
      if (this.opened) {
        modal.show();
      } else {
        modal.hide();
        this.$emit("hidden");
      }
    },
  },
  mounted() {
    this.$refs.contentModal.addEventListener("hidden.bs.modal", this.hidden);
  },
  methods: {
    hidden() {
      this.$emit("hidden");
      const container = this.$refs.contentModal;
      container.removeEventListener("click", this.stop);
    },

    stop(e) {
      e.stopPropagation();
    },
  },
};
</script>

<style scoped lang="scss"></style>
